import { render, staticRenderFns } from "./AccountSetting.vue?vue&type=template&id=02c1a04b&scoped=true&"
import script from "./AccountSetting.vue?vue&type=script&lang=js&"
export * from "./AccountSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02c1a04b",
  null
  
)

export default component.exports